import { INQUIRY_MASTER_DATA } from 'src/actions/constants';

const volumeConversionMap = {
  cbm: {
    cbm: 1,
    'cu in': 61023.7,
    'cu ft': 35.3147,
    'cu cm': 1e6,
    'cu mm': 1e9,
  },
  'cu in': {
    cbm: 1.63871e-5,
    'cu in': 1,
    'cu ft': 0.000578704,
    'cu cm': 16.387064,
    'cu mm': 16.387064e3,
  },
  'cu ft': {
    cbm: 0.0283168,
    'cu in': 1728,
    'cu ft': 1,
    'cu cm': 28316.846592,
    'cu mm': 28316.846592e3,
  },
  'cu mm': {
    cbm: 1e-9,
    'cu in': 0.0000610237,
    'cu ft': 3.53147e-8,
    'cu cm': 1e-3,
    'cu mm': 1,
  },
  meter: {
    cbm: 1,
    'cu in': 61023.7,
    'cu ft': 35.3147,
    'cu cm': 1e6,
    'cu mm': 1e9,
  },
};

const defaultState = {
  masterData: null,
};
export default function (state: any = defaultState, action) {
  switch (action.type) {
    case INQUIRY_MASTER_DATA:
      const { volumeConverterMap } = action.data;
      return {
        ...state,
        masterData: {
          ...action.data,
          volumeConverterMap : {
            ...volumeConverterMap,
            ...volumeConversionMap,
          },
        },
      };
    default: return state;
  }
}
